import "./App.css";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from "./Pages/Home/Home";
import LoginPage from "./Pages/LoginPage/LoginPage";
import Dashboard from "./Pages/Dashboard/Dashboard";
import SkillDashboard from "./Pages/Dashboard/Skills/SkillDashboard";
import ProjectDashboard from "./Pages/Dashboard/Projects/ProjectDashboard";
import ExperienceDashboard from "./Pages/Dashboard/Experiences/ExperienceDashboard";
import ThemeDashboard from "./Pages/Dashboard/Themes/ThemeDashboard";
import axios from "axios";
import { useEffect } from "react";

const App = () => {

    useEffect(() => {
        const visitorUrl = process.env.REACT_APP_VISITOR_INFO;
        const notifyUrl = process.env.REACT_APP_NOTIFICATION_BASE_URL;

        if (!visitorUrl || !notifyUrl) return; // early exit if env missing

        axios.get(visitorUrl)
            .then(response => {

                const payload = {
                    status: response.data.status,
                    message: response.data.message || null,
                    query: response.data.query,
                    continent: response.data.continent || null,
                    continentCode: response.data.continentCode || null,
                    country: response.data.country || null,
                    countryCode: response.data.countryCode || null,
                    region: response.data.region || null,
                    regionName: response.data.regionName || null,
                    city: response.data.city || null,
                    zip: response.data.zip || null,
                    lat: response.data.lat || null,
                    lon: response.data.lon || null,
                    timezone: response.data.timezone || null,
                    isp: response.data.isp || null,
                    org: response.data.org || null,
                    as: response.data.as || null,
                };

                return axios.post(notifyUrl, payload);
            })
            .then(postRes => {
            })
            .catch(error => {
                console.error(error.response ? error.response.data : error.message);
            });
    }, []);

    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/dashboard/themes" element={<ThemeDashboard />} />
                <Route path="/dashboard/skills" element={<SkillDashboard />} />
                <Route path="/dashboard/projects" element={<ProjectDashboard />} />
                <Route path="/dashboard/experiences" element={<ExperienceDashboard />} />
            </Routes>
        </Router>
    )
}

export default App;